"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.togglePassword = void 0;
/**
 *  Template:
 *  .toggle-selector
 *      .toggle-selector__input
 *      .toggle-selector__button
 */
function togglePassword(element) {
    var blockClass = 'password-group';
    var inputSelector = ".".concat(blockClass, "__input");
    var buttonSelector = ".".concat(blockClass, "__button");
    var typePassword = 'password';
    var typeText = 'text';
    var showClass = 'fa-eye';
    var hideClass = 'fa-eye-slash';
    var input = element.querySelector(inputSelector);
    if (!input) {
        throw elementNotFound();
    }
    var button = element.querySelector(buttonSelector);
    if (!button) {
        throw elementNotFound();
    }
    var icon = button.querySelector('.fa');
    if (!icon) {
        throw elementNotFound();
    }
    button.addEventListener('click', function () {
        if (input.getAttribute('type') !== typePassword) {
            input.setAttribute('type', typePassword);
            icon.classList.replace(hideClass, showClass);
            return;
        }
        input.setAttribute('type', typeText);
        icon.classList.replace(showClass, hideClass);
    });
}
exports.togglePassword = togglePassword;
function elementNotFound() {
    return new Error('Element not found.');
}
